<template>
    <div class="parameterTable">
        <div class="tableContent">
            <div class="title">{{ title }}</div>
            <div class="topForm">
                <div class="resetBox">
                    <div @click="resetChange" class="ResetBtn">
                        <span>{{ $t('Reset') }}</span>
                        <img src="../../assets/index/reseticon.png" alt="" />
                    </div>
                </div>
                <div class="selectBox">
                    <div class="selectItem">
                        <div style="border-bottom: 1px solid #000;height: 39px;margin-right: 30px;"></div>
                    </div>
                    <div class="selectItem">
                        <el-select  @change="formDataChange" :style="{ width: `${selectWidth}px` }" :placeholder="$t('i18n_156')"
                            v-model="form.working_length">
                            <el-option v-for="(item, index) in working_length" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="selectItem">
                        <el-select @change="formDataChange" :style="{ width: `${selectWidth}px` }" :placeholder="$t('i18n_156')"
                            v-model="form.diameter_of_distal_end">
                            <el-option v-for="(item, index) in diameter_of_distal_end" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="selectItem">
                        <el-select @change="formDataChange" :style="{ width: `${selectWidth}px` }" :placeholder="$t('i18n_156')"
                            v-model="form.diameter_ofinstrument_channel">
                            <el-option v-for="(item, index) in diameter_ofinstrument_channel" :key="index" :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="selectItem">
                        <el-select @change="formDataChange" :style="{ width: `${selectWidth}px` }" :placeholder="$t('i18n_156')"
                            v-model="form.range_ofbending">
                            <el-option v-for="(item, index) in range_ofbending" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="selectItem">
                        <el-select @change="formDataChange" :style="{ width: `${selectWidth}px` }" :placeholder="$t('i18n_156')"
                            v-model="form.width">
                            <el-option v-for="(item, index) in width" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <el-table size="small" fit height="calc(100vh - 470px)" :data="tableList">
                <el-table-column property="model" label="Model"></el-table-column>
                <el-table-column property="working_length" label="Working length (mm)"></el-table-column>
                <el-table-column property="diameter_of_distal_end"
                    label="Diameter of distal end (mm)"></el-table-column>
                <el-table-column property="diameter_ofinstrument_channel"
                    label="Diameter of instrument channel (mm)"></el-table-column>
                <el-table-column property="range_ofbending" label="Range of bending"></el-table-column>
                <el-table-column property="width" label="Field of view"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        title: {
            type: String,
            default: 'Endoscopes',
        },
        tableList: {
            type: Array,
            default: (() => [])
        },
        select_data: {
            type: Object,
            default: (() => { })
        },
    },
    computed: {
        diameter_of_distal_end() {
            return this.select_data.diameter_of_distal_end || []
        },
        diameter_ofinstrument_channel() {
            return this.select_data.diameter_ofinstrument_channel || []
        },
        range_ofbending() {
            return this.select_data.range_ofbending || []
        },
        width() {
            return this.select_data.width || []
        },
        working_length() {
            return this.select_data.working_length || []
        },
    },
    data() {
        return {
            selectWidth: 167,
            form: {
                working_length: null,
                diameter_of_distal_end: null,
                diameter_ofinstrument_channel: null,
                range_ofbending: null,
                width: null,
            },
            options: [],
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        resetChange() {
            this.form = {
                working_length: null,
                diameter_of_distal_end: null,
                diameter_ofinstrument_channel: null,
                range_ofbending: null,
                width: null,
            }
            this.formDataChange()
        },
        formDataChange() {
            this.$emit('change', this.form)
        }
    },
}
</script>

<style scoped lang="scss">
.parameterTable {
    width: 100%;
    margin: auto;
    padding: 50px 0 20px 0;

    .title {
        font-size: 32px;
        color: #000000;
        padding: 10px 0 22px 0;
        text-align: center;
        line-height: 32px;
    }

    .topForm {
        .resetBox {
            display: flex;
            justify-content: flex-end;

            .ResetBtn {
                display: inline-flex;
                align-items: center;
                cursor: pointer;
                margin-right: 20px;

                span {
                    color: #A3A3A3;
                    font-size: 18px;
                    margin-right: 15px;
                    font-weight: 300;
                }

                img {
                    width: 17px;
                    height: 13px;
                }
            }
        }

        .selectBox {
            display: flex;
            justify-content: space-between;
            margin-top: 30px;

            .selectItem {
                flex: 1;
            }
        }
    }
}

::v-deep.parameterTable .el-dialog {
    width: 1200px;
}

::v-deep.el-table th.el-table__cell>.cell {
    font-weight: 500;
    color: #000000;
}

::v-deep .el-table th.el-table__cell.is-leaf {
    vertical-align: top;
}

::v-deep.el-table {
    color: #000000;
}

::v-deep.el-table .cell {
    word-break: normal;
}

::v-deep.selectBox .el-input__inner {
    border-radius: 0px;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-bottom: 1px solid #000000;
}

@media screen and (max-width:1200px) {

    .parameterTable {
        width: 100%;
        margin: auto;
        overflow: auto;
        padding: 50px 0;

        .tableContent {
            width: 1200px;
        }

        .title {
            font-size: 32px;
            color: #000000;
            padding: 30px 0;
            text-align: center;
            line-height: 32px;
        }

        .topForm {
            .resetBox {
                display: flex;
                justify-content: flex-end;

                .ResetBtn {
                    display: inline-flex;
                    align-items: center;
                    cursor: pointer;
                    margin-right: 20px;

                    span {
                        color: #A3A3A3;
                        font-size: 18px;
                        margin-right: 15px;
                        font-weight: 300;
                    }

                    img {
                        width: 17px;
                        height: 13px;
                    }
                }
            }

            .selectBox {
                display: flex;
                justify-content: space-between;
                margin-top: 30px;

                .selectItem {
                    flex: 1;
                }
            }
        }
    }
}
</style>